import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/lib/components/Select";
import { FontCategoryDto } from "@repo/api/font";
import { cn } from "@/lib/utils";
import { categoryLabels } from "./font-utils";

export type FontOwnershipFilter = "ALL" | "USER" | "LIBRARY";
export type FontCategoryFilter = FontCategoryDto | "ALL";

const ownershipLabels: Record<FontOwnershipFilter, string> = {
  ALL: "All Fonts",
  USER: "Team Fonts",
  LIBRARY: "Built-in Fonts",
};

export function FontFilters({
  ownership,
  onOwnershipChange,
  category,
  onCategoryChange,
}: {
  ownership: FontOwnershipFilter;
  onOwnershipChange: (value: FontOwnershipFilter) => void;
  category: FontCategoryFilter;
  onCategoryChange: (value: FontCategoryFilter) => void;
}) {
  return (
    <div className="flex-1 p-6">
      <h2 className="mb-5 flex items-center gap-2 font-semibold text-text-primary">
        Filters
      </h2>
      <div className="flex flex-col gap-4">
        <Select
          value={ownership}
          onValueChange={(value) =>
            onOwnershipChange(value as FontOwnershipFilter)
          }
        >
          <SelectTrigger
            className={cn(
              "w-full",
              ownership === "ALL" && "text-text-secondary",
            )}
          >
            <SelectValue>{ownershipLabels[ownership]}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">{ownershipLabels.ALL}</SelectItem>
            <SelectItem value="USER">{ownershipLabels.USER}</SelectItem>
            <SelectItem value="LIBRARY">{ownershipLabels.LIBRARY}</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={category}
          onValueChange={(value) =>
            onCategoryChange(value as FontCategoryFilter)
          }
        >
          <SelectTrigger
            className={cn(
              "w-full",
              category === "ALL" && "text-text-secondary",
            )}
          >
            <SelectValue>{categoryLabels[category]}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {(Object.keys(categoryLabels) as FontCategoryFilter[]).map(
              (value) => (
                <SelectItem key={value} value={value}>
                  {categoryLabels[value]}
                </SelectItem>
              ),
            )}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
